/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as ActivateRouteImport } from "./routes/activate"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as RegisterRouteImport } from "./routes/register"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as VerifyRouteImport } from "./routes/verify"
import { Route as VerifyEmailRouteImport } from "./routes/verify-email"
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account"
import { Route as AuthenticatedApiKeysRouteImport } from "./routes/_authenticated/api-keys"
import { Route as AuthenticatedBillingRouteImport } from "./routes/_authenticated/billing"
import { Route as CliAuthorizeRouteImport } from "./routes/cli.authorize"
import { Route as AuthenticatedAppsIndexRouteImport } from "./routes/_authenticated/apps/index"
import { Route as AuthenticatedAppsAppNameRouteImport } from "./routes/_authenticated/apps/$appName"
import { Route as AuthenticatedBillingCancelRouteImport } from "./routes/_authenticated/billing.cancel"
import { Route as AuthenticatedBillingSuccessRouteImport } from "./routes/_authenticated/billing.success"
import { Route as AuthenticatedStaffIndexRouteImport } from "./routes/_authenticated/staff/index"
import { Route as AuthenticatedStaffAccountIdRouteImport } from "./routes/_authenticated/staff/$accountId"
import { Route as AuthenticatedAppsAppNameSettingsRouteImport } from "./routes/_authenticated/apps/$appName_.settings"
import { Route as AuthenticatedAppsAppNameDeploymentsDeploymentNameRouteImport } from "./routes/_authenticated/apps/$appName_.deployments.$deploymentName"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: "/activate",
  path: "/activate",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: "/verify",
  path: "/verify",
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApiKeysRoute = AuthenticatedApiKeysRouteImport.update({
  id: "/api-keys",
  path: "/api-keys",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const CliAuthorizeRoute = CliAuthorizeRouteImport.update({
  id: "/cli/authorize",
  path: "/cli/authorize",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: "/apps/",
  path: "/apps/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppsAppNameRoute =
  AuthenticatedAppsAppNameRouteImport.update({
    id: "/apps/$appName",
    path: "/apps/$appName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingCancelRoute =
  AuthenticatedBillingCancelRouteImport.update({
    id: "/cancel",
    path: "/cancel",
    getParentRoute: () => AuthenticatedBillingRoute,
  } as any)
const AuthenticatedBillingSuccessRoute =
  AuthenticatedBillingSuccessRouteImport.update({
    id: "/success",
    path: "/success",
    getParentRoute: () => AuthenticatedBillingRoute,
  } as any)
const AuthenticatedStaffIndexRoute = AuthenticatedStaffIndexRouteImport.update({
  id: "/staff/",
  path: "/staff/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStaffAccountIdRoute =
  AuthenticatedStaffAccountIdRouteImport.update({
    id: "/staff/$accountId",
    path: "/staff/$accountId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppsAppNameSettingsRoute =
  AuthenticatedAppsAppNameSettingsRouteImport.update({
    id: "/apps/$appName_/settings",
    path: "/apps/$appName/settings",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute =
  AuthenticatedAppsAppNameDeploymentsDeploymentNameRouteImport.update({
    id: "/apps/$appName_/deployments/$deploymentName",
    path: "/apps/$appName/deployments/$deploymentName",
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/activate": typeof ActivateRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/verify": typeof VerifyRoute
  "/verify-email": typeof VerifyEmailRoute
  "/account": typeof AuthenticatedAccountRoute
  "/api-keys": typeof AuthenticatedApiKeysRoute
  "/billing": typeof AuthenticatedBillingRouteWithChildren
  "/cli/authorize": typeof CliAuthorizeRoute
  "/apps/$appName": typeof AuthenticatedAppsAppNameRoute
  "/billing/cancel": typeof AuthenticatedBillingCancelRoute
  "/billing/success": typeof AuthenticatedBillingSuccessRoute
  "/staff/$accountId": typeof AuthenticatedStaffAccountIdRoute
  "/apps/": typeof AuthenticatedAppsIndexRoute
  "/staff/": typeof AuthenticatedStaffIndexRoute
  "/apps/$appName/settings": typeof AuthenticatedAppsAppNameSettingsRoute
  "/apps/$appName/deployments/$deploymentName": typeof AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/activate": typeof ActivateRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/verify": typeof VerifyRoute
  "/verify-email": typeof VerifyEmailRoute
  "/account": typeof AuthenticatedAccountRoute
  "/api-keys": typeof AuthenticatedApiKeysRoute
  "/billing": typeof AuthenticatedBillingRouteWithChildren
  "/cli/authorize": typeof CliAuthorizeRoute
  "/apps/$appName": typeof AuthenticatedAppsAppNameRoute
  "/billing/cancel": typeof AuthenticatedBillingCancelRoute
  "/billing/success": typeof AuthenticatedBillingSuccessRoute
  "/staff/$accountId": typeof AuthenticatedStaffAccountIdRoute
  "/apps": typeof AuthenticatedAppsIndexRoute
  "/staff": typeof AuthenticatedStaffIndexRoute
  "/apps/$appName/settings": typeof AuthenticatedAppsAppNameSettingsRoute
  "/apps/$appName/deployments/$deploymentName": typeof AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/activate": typeof ActivateRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/verify": typeof VerifyRoute
  "/verify-email": typeof VerifyEmailRoute
  "/_authenticated/account": typeof AuthenticatedAccountRoute
  "/_authenticated/api-keys": typeof AuthenticatedApiKeysRoute
  "/_authenticated/billing": typeof AuthenticatedBillingRouteWithChildren
  "/cli/authorize": typeof CliAuthorizeRoute
  "/_authenticated/apps/$appName": typeof AuthenticatedAppsAppNameRoute
  "/_authenticated/billing/cancel": typeof AuthenticatedBillingCancelRoute
  "/_authenticated/billing/success": typeof AuthenticatedBillingSuccessRoute
  "/_authenticated/staff/$accountId": typeof AuthenticatedStaffAccountIdRoute
  "/_authenticated/apps/": typeof AuthenticatedAppsIndexRoute
  "/_authenticated/staff/": typeof AuthenticatedStaffIndexRoute
  "/_authenticated/apps/$appName_/settings": typeof AuthenticatedAppsAppNameSettingsRoute
  "/_authenticated/apps/$appName_/deployments/$deploymentName": typeof AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/activate"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify"
    | "/verify-email"
    | "/account"
    | "/api-keys"
    | "/billing"
    | "/cli/authorize"
    | "/apps/$appName"
    | "/billing/cancel"
    | "/billing/success"
    | "/staff/$accountId"
    | "/apps/"
    | "/staff/"
    | "/apps/$appName/settings"
    | "/apps/$appName/deployments/$deploymentName"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/activate"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify"
    | "/verify-email"
    | "/account"
    | "/api-keys"
    | "/billing"
    | "/cli/authorize"
    | "/apps/$appName"
    | "/billing/cancel"
    | "/billing/success"
    | "/staff/$accountId"
    | "/apps"
    | "/staff"
    | "/apps/$appName/settings"
    | "/apps/$appName/deployments/$deploymentName"
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/activate"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/verify"
    | "/verify-email"
    | "/_authenticated/account"
    | "/_authenticated/api-keys"
    | "/_authenticated/billing"
    | "/cli/authorize"
    | "/_authenticated/apps/$appName"
    | "/_authenticated/billing/cancel"
    | "/_authenticated/billing/success"
    | "/_authenticated/staff/$accountId"
    | "/_authenticated/apps/"
    | "/_authenticated/staff/"
    | "/_authenticated/apps/$appName_/settings"
    | "/_authenticated/apps/$appName_/deployments/$deploymentName"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyRoute: typeof VerifyRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  CliAuthorizeRoute: typeof CliAuthorizeRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/activate": {
      id: "/activate"
      path: "/activate"
      fullPath: "/activate"
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/register": {
      id: "/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/verify": {
      id: "/verify"
      path: "/verify"
      fullPath: "/verify"
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/verify-email": {
      id: "/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/account": {
      id: "/_authenticated/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/api-keys": {
      id: "/_authenticated/api-keys"
      path: "/api-keys"
      fullPath: "/api-keys"
      preLoaderRoute: typeof AuthenticatedApiKeysRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/billing": {
      id: "/_authenticated/billing"
      path: "/billing"
      fullPath: "/billing"
      preLoaderRoute: typeof AuthenticatedBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/cli/authorize": {
      id: "/cli/authorize"
      path: "/cli/authorize"
      fullPath: "/cli/authorize"
      preLoaderRoute: typeof CliAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/apps/": {
      id: "/_authenticated/apps/"
      path: "/apps"
      fullPath: "/apps/"
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/apps/$appName": {
      id: "/_authenticated/apps/$appName"
      path: "/apps/$appName"
      fullPath: "/apps/$appName"
      preLoaderRoute: typeof AuthenticatedAppsAppNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/billing/cancel": {
      id: "/_authenticated/billing/cancel"
      path: "/cancel"
      fullPath: "/billing/cancel"
      preLoaderRoute: typeof AuthenticatedBillingCancelRouteImport
      parentRoute: typeof AuthenticatedBillingRoute
    }
    "/_authenticated/billing/success": {
      id: "/_authenticated/billing/success"
      path: "/success"
      fullPath: "/billing/success"
      preLoaderRoute: typeof AuthenticatedBillingSuccessRouteImport
      parentRoute: typeof AuthenticatedBillingRoute
    }
    "/_authenticated/staff/": {
      id: "/_authenticated/staff/"
      path: "/staff"
      fullPath: "/staff/"
      preLoaderRoute: typeof AuthenticatedStaffIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/staff/$accountId": {
      id: "/_authenticated/staff/$accountId"
      path: "/staff/$accountId"
      fullPath: "/staff/$accountId"
      preLoaderRoute: typeof AuthenticatedStaffAccountIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/apps/$appName_/settings": {
      id: "/_authenticated/apps/$appName_/settings"
      path: "/apps/$appName/settings"
      fullPath: "/apps/$appName/settings"
      preLoaderRoute: typeof AuthenticatedAppsAppNameSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/apps/$appName_/deployments/$deploymentName": {
      id: "/_authenticated/apps/$appName_/deployments/$deploymentName"
      path: "/apps/$appName/deployments/$deploymentName"
      fullPath: "/apps/$appName/deployments/$deploymentName"
      preLoaderRoute: typeof AuthenticatedAppsAppNameDeploymentsDeploymentNameRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedBillingRouteChildren {
  AuthenticatedBillingCancelRoute: typeof AuthenticatedBillingCancelRoute
  AuthenticatedBillingSuccessRoute: typeof AuthenticatedBillingSuccessRoute
}

const AuthenticatedBillingRouteChildren: AuthenticatedBillingRouteChildren = {
  AuthenticatedBillingCancelRoute: AuthenticatedBillingCancelRoute,
  AuthenticatedBillingSuccessRoute: AuthenticatedBillingSuccessRoute,
}

const AuthenticatedBillingRouteWithChildren =
  AuthenticatedBillingRoute._addFileChildren(AuthenticatedBillingRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRoute
  AuthenticatedApiKeysRoute: typeof AuthenticatedApiKeysRoute
  AuthenticatedBillingRoute: typeof AuthenticatedBillingRouteWithChildren
  AuthenticatedAppsAppNameRoute: typeof AuthenticatedAppsAppNameRoute
  AuthenticatedStaffAccountIdRoute: typeof AuthenticatedStaffAccountIdRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedStaffIndexRoute: typeof AuthenticatedStaffIndexRoute
  AuthenticatedAppsAppNameSettingsRoute: typeof AuthenticatedAppsAppNameSettingsRoute
  AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute: typeof AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,
  AuthenticatedApiKeysRoute: AuthenticatedApiKeysRoute,
  AuthenticatedBillingRoute: AuthenticatedBillingRouteWithChildren,
  AuthenticatedAppsAppNameRoute: AuthenticatedAppsAppNameRoute,
  AuthenticatedStaffAccountIdRoute: AuthenticatedStaffAccountIdRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedStaffIndexRoute: AuthenticatedStaffIndexRoute,
  AuthenticatedAppsAppNameSettingsRoute: AuthenticatedAppsAppNameSettingsRoute,
  AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute:
    AuthenticatedAppsAppNameDeploymentsDeploymentNameRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyRoute: VerifyRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  CliAuthorizeRoute: CliAuthorizeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
